<script lang="ts" setup>
import { useAuthStore } from '@/modules/auth'
import { storeToRefs } from 'pinia'

const auth = useAuthStore()
const { loaders } = storeToRefs(auth)
</script>

<template>
  <section
    v-if="loaders.isLoadingUser || loaders.isAuthenticating"
    class="fixed z-50 top-0 left-0 w-screen h-screen bg-surface-0 dark:bg-surface-700 flex items-center justify-center"
  >
    <ProgressSpinner />
  </section>
</template>
